import createIcon from '../../createIcon';

/**
 * @component @name NotificationsOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAxOC40NEw0Ljc3IDMuMjRMMy41IDQuNTFMNi4zIDcuMzFWNy4zMkM1Ljc4IDguMzEgNS41IDkuNDggNS41IDEwLjc0VjE1Ljc0TDMuNSAxNy43NFYxOC43NEgxNy4yM0wxOS4yMyAyMC43NEwyMC41IDE5LjQ3TDE5LjUgMTguNDRaTTExLjUgMjEuNzVDMTIuNjEgMjEuNzUgMTMuNSAyMC44NiAxMy41IDE5Ljc1SDkuNUM5LjUgMjAuODYgMTAuMzkgMjEuNzUgMTEuNSAyMS43NVpNMTcuNSAxNC40M1YxMC43NUMxNy41IDcuNjcgMTUuODYgNS4xMSAxMyA0LjQzVjMuNzVDMTMgMi45MiAxMi4zMyAyLjI1IDExLjUgMi4yNUMxMC42NyAyLjI1IDEwIDIuOTIgMTAgMy43NVY0LjQzQzkuODUgNC40NiA5LjcxIDQuNTEgOS41OCA0LjU1QzkuNDggNC41OCA5LjM4IDQuNjIgOS4yOCA0LjY2SDkuMjdDOS4yNiA0LjY2IDkuMjYgNC42NiA5LjI1IDQuNjdDOS4wMiA0Ljc2IDguNzkgNC44NyA4LjU3IDQuOThDOC41NyA0Ljk4IDguNTYgNC45OCA4LjU2IDQuOTlMMTcuNSAxNC40M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotificationsOff = createIcon('NotificationsOff', [
  [
    'path',
    {
      d: 'M19.5 18.44L4.77 3.24L3.5 4.51L6.3 7.31V7.32C5.78 8.31 5.5 9.48 5.5 10.74V15.74L3.5 17.74V18.74H17.23L19.23 20.74L20.5 19.47L19.5 18.44ZM11.5 21.75C12.61 21.75 13.5 20.86 13.5 19.75H9.5C9.5 20.86 10.39 21.75 11.5 21.75ZM17.5 14.43V10.75C17.5 7.67 15.86 5.11 13 4.43V3.75C13 2.92 12.33 2.25 11.5 2.25C10.67 2.25 10 2.92 10 3.75V4.43C9.85 4.46 9.71 4.51 9.58 4.55C9.48 4.58 9.38 4.62 9.28 4.66H9.27C9.26 4.66 9.26 4.66 9.25 4.67C9.02 4.76 8.79 4.87 8.57 4.98C8.57 4.98 8.56 4.98 8.56 4.99L17.5 14.43Z',
      key: '111n51',
    },
  ],
]);

export default NotificationsOff;
